// extracted by mini-css-extract-plugin
export default {"gray500":"#adb5bd","CallToAction":"CallToAction_CallToAction__-W5di"};